export default __webpack_public_path__ + "static/logo-inverted-e56083a5b5e77db7f7319e2b8045c0b2.svg";